import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/faqs';
import { siteConfig } from '@/mocks/site';
import { useSeo } from '@/hooks/useSeo';
import Breadcrumbs from '@/components/feature/Breadcrumbs';

export default function FaqPage() {
  const [open, setOpen] = useState<number | null>(0);

  useSeo({
    title: '常见问题 - 17爆料网',
    description:
      '17爆料网常见问题解答：线索来源、如何判断爆料是否可靠、如何投稿、隐私处理与内容更新频率等。',
    keywords: '17爆料网,17爆料网投稿,17爆料网信源,17爆料网常见问题',
    path: '/faq',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((f) => ({
          '@type': 'Question',
          name: f.q,
          acceptedAnswer: { '@type': 'Answer', text: f.a },
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://dyfscl.cn/' },
          { '@type': 'ListItem', position: 2, name: '常见问题', item: 'https://dyfscl.cn/faq' },
        ],
      },
    ],
  });

  return (
    <>
      <section className="bg-background-100 border-b border-background-200">
        <div className="px-4 md:px-8 pt-6 pb-12">
          <Breadcrumbs items={[{ label: '常见问题' }]} />
          <div className="mt-8 max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs tracking-widest text-primary-700 font-label mb-4">
              <span className="w-6 h-px bg-primary-500"></span>
              FAQ
            </span>
            <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
              关于信源、核实与投稿
            </h1>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              这里集中回答读者最常问的问题。如果你关心的内容不在下面，欢迎写信到 {siteConfig.email}。
            </p>
          </div>
        </div>
      </section>

      <section className="px-4 md:px-8 py-10 md:py-14">
        <div className="grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {faqs.map((f, i) => (
                <li key={f.q} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                  <h2 className="m-0">
                    <button
                      type="button"
                      onClick={() => setOpen(open === i ? null : i)}
                      aria-expanded={open === i}
                      className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                    >
                      <span className="font-heading font-bold text-base text-foreground-950">{f.q}</span>
                      <i
                        className={
                          open === i ? 'ri-subtract-line text-primary-600 text-lg' : 'ri-add-line text-foreground-400 text-lg'
                        }
                      ></i>
                    </button>
                  </h2>
                  {open === i && (
                    <div className="px-5 pb-5 pt-4 border-t border-background-100 text-sm text-foreground-600 leading-relaxed">
                      {f.a}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-6">
              <h2 className="font-heading font-bold text-base text-foreground-950 mb-3">快速导航</h2>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/about" className="text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer flex items-center gap-2">
                    <i className="ri-arrow-right-s-line"></i>关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer flex items-center gap-2">
                    <i className="ri-arrow-right-s-line"></i>我要爆料
                  </Link>
                </li>
                <li>
                  <Link to="/#tracking" className="text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer flex items-center gap-2">
                    <i className="ri-arrow-right-s-line"></i>独家追踪时间线
                  </Link>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}